var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8"}},[_c('v-card',{staticClass:"mx-auto"},[_c('div',{staticClass:"mx-auto text-center"},[_c('custom-loading',{attrs:{"type":"updateReservation"}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }